export const RESET_SCROLL_POSITION = "RESET_SCROLL_POSITION";
export const SET_SCROLL_POSITION = "SET_SCROLL_POSITION";

export const REMOVE_NAVBAR_TOP = "REMOVE_NAVBAR_TOP";
export const ACTIVE_NAVBAR_TOP = "ACTIVE_NAVBAR_TOP";
